import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { createFoldOutbound } from '../../../../api/outbound/pokerOutbounds';
import { useSocketSend } from '../../../../context/webSocket/webSocketContext';
import { Button } from '../../pixiComponents/button';
export const PixiFoldButton = ({ bounds, myTurnProperties }) => {
    const socketSend = useSocketSend();
    const onClickFold = useCallback(() => {
        socketSend(createFoldOutbound(myTurnProperties.betSequenceNumber));
    }, [myTurnProperties, socketSend]);
    return (_jsx(Button, { pixiObjectData: { type: 'fold-button' }, onClick: onClickFold, labelProperties: { label: 'FOLD', bitmapTextStyleType: 'button-label', labelPixiDataType: 'fold-button-label' }, bounds: bounds, accentColor: 'red' }));
};
